var _circle, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReelControlsPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#BDC7C7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.69519,
    y: 17.2651,
    width: 13.5337,
    height: 13.1866,
    transform: "rotate(-45 7.69519 17.2651)",
    fill: "#2E3838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelControlsPointer);
export default __webpack_public_path__ + "static/media/reel_controls_pointer.d626b4965840dc52a88703c06e29847c.svg";
export { ForwardRef as ReactComponent };